import { cn } from '../../lib/cn';
import styles from './Pill.module.css';

/**
 * The comp's ubiquitous rounded chip. Used as a static label (section eyebrow,
 * industry tag) and as a control (product-tour tabs), hence the `as` escape.
 */
export function Pill({ as: Tag = 'span', tone, size, interactive, className, children, ...rest }) {
  return (
    <Tag
      className={cn(
        styles.pill,
        tone && styles[tone],
        size && styles[size],
        (interactive || Tag === 'button') && styles.interactive,
        className,
      )}
      {...(Tag === 'button' ? { type: 'button' } : null)}
      {...rest}
    >
      {children}
    </Tag>
  );
}
